export default {
    CHANGE_NOTE: function(state, { roomGroupId, noteId }){
        let roomShareNote = this.getters['shareNote/roomShareNote'];
        roomShareNote.noteId = noteId;
    },
}
